/* eslint-disable prettier/prettier */
// Centroides aproximados de cada unidade federativa do Brasil.
// Fonte: IBGE — coordenadas geográficas do centro geográfico de cada UF.

export interface StateCentroid {
  uf: string;
  name: string;
  lat: number;
  lng: number;
}

export const BRAZIL_STATE_CENTROIDS: Record<string, StateCentroid> = {
  AC: { uf: 'AC', name: 'Acre', lat: -9.02, lng: -70.81 },
  AL: { uf: 'AL', name: 'Alagoas', lat: -9.62, lng: -36.82 },
  AP: { uf: 'AP', name: 'Amapá', lat: 1.41, lng: -51.77 },
  AM: { uf: 'AM', name: 'Amazonas', lat: -4.15, lng: -65.82 },
  BA: { uf: 'BA', name: 'Bahia', lat: -12.47, lng: -41.28 },
  CE: { uf: 'CE', name: 'Ceará', lat: -5.09, lng: -39.45 },
  DF: { uf: 'DF', name: 'Distrito Federal', lat: -15.78, lng: -47.93 },
  ES: { uf: 'ES', name: 'Espírito Santo', lat: -19.57, lng: -40.74 },
  GO: { uf: 'GO', name: 'Goiás', lat: -15.98, lng: -49.86 },
  MA: { uf: 'MA', name: 'Maranhão', lat: -5.06, lng: -45.29 },
  MT: { uf: 'MT', name: 'Mato Grosso', lat: -12.81, lng: -56.02 },
  MS: { uf: 'MS', name: 'Mato Grosso do Sul', lat: -20.51, lng: -54.54 },
  MG: { uf: 'MG', name: 'Minas Gerais', lat: -18.1, lng: -44.38 },
  PA: { uf: 'PA', name: 'Pará', lat: -3.79, lng: -52.48 },
  PB: { uf: 'PB', name: 'Paraíba', lat: -7.12, lng: -36.72 },
  PR: { uf: 'PR', name: 'Paraná', lat: -24.89, lng: -51.55 },
  PE: { uf: 'PE', name: 'Pernambuco', lat: -8.38, lng: -37.86 },
  PI: { uf: 'PI', name: 'Piauí', lat: -7.72, lng: -42.73 },
  RJ: { uf: 'RJ', name: 'Rio de Janeiro', lat: -22.25, lng: -42.66 },
  RN: { uf: 'RN', name: 'Rio Grande do Norte', lat: -5.82, lng: -36.95 },
  RS: { uf: 'RS', name: 'Rio Grande do Sul', lat: -29.68, lng: -53.81 },
  RO: { uf: 'RO', name: 'Rondônia', lat: -10.91, lng: -62.8 },
  RR: { uf: 'RR', name: 'Roraima', lat: 2.09, lng: -61.4 },
  SC: { uf: 'SC', name: 'Santa Catarina', lat: -27.45, lng: -50.95 },
  SP: { uf: 'SP', name: 'São Paulo', lat: -22.19, lng: -48.79 },
  SE: { uf: 'SE', name: 'Sergipe', lat: -10.57, lng: -37.45 },
  TO: { uf: 'TO', name: 'Tocantins', lat: -9.97, lng: -48.38 },
};

// Bounding box aproximado do Brasil para fit inicial do mapa
export const BRAZIL_BOUNDS: [[number, number], [number, number]] = [
  [-33.75, -73.99],
  [5.27, -34.79],
];
